<template>
  <CModal
    :show.sync="visible"
    size="xl"
    :title="modalTitle"
  >
    <div v-if="permissions && Object.keys(permissions).length > 0">
      <div class="search-box mb-3">
        <CInput
          v-model="searchTerm"
          :placeholder="$gettext('Search permissions...')"
        >
          <template #prepend>
            <CIcon name="cilSearch" />
          </template>
        </CInput>
      </div>
      
      <Permission
        :permissions="permissions"
        :active="permissions"
        :search-filter="searchTerm"
      />
    </div>
    
    <div v-else class="text-center text-muted py-4">
      <translate translate-context="permissions.modal">No permissions found for this role</translate>
    </div>
    
    <template #footer>
      <CButton color="secondary" @click="visible = false">
        <translate translate-context="permissions.modal">Close</translate>
      </CButton>
    </template>
  </CModal>
</template>

<script>
import Permission from '@/domain/roles/components/Permission.vue'

export default {
  name: 'RolePermissionsModal',
  
  components: {
    Permission
  },
  
  props: {
    scope: {
      type: Object,
      default: () => ({})
    }
  },
  
  data() {
    return {
      visible: false,
      permissions: null,
      role: null,
      searchTerm: ''
    }
  },
  
  computed: {
    modalTitle() {
      if (this.role) {
        return this.$gettext('Permissions for role: %{name}').replace('%{name}', this.role.name)
      }
      return this.$gettext('Role Permissions')
    }
  },
  
  methods: {
    show(permissions, role) {
      this.permissions = permissions
      this.role = role
      this.searchTerm = ''
      this.visible = true
    },
    
    hide() {
      this.visible = false
      this.permissions = null
      this.role = null
      this.searchTerm = ''
    }
  }
}
</script>

<style scoped>
.search-box {
  max-width: 400px;
}
</style>